/**
 * v-lazy: 图片进入可视区域时再设置 src
 *
 * 用法：
 * <img v-lazy="imgUrl" />
 * <img v-lazy="{ src: imgUrl, placeholder: placeUrl, error: errUrl, rootMargin: '200px' }" />
 */
function resolveBinding(binding) {
  const v = binding?.value
  if (typeof v === 'string') return { src: v }
  return v || {}
}

export const vLazy = {
  mounted(el, binding) {
    const { src, placeholder, error, rootMargin = '200px 0px' } = resolveBinding(binding)
    if (!src) return

    if (placeholder) el.src = placeholder

    const load = () => {
      const img = new Image()
      img.onload = () => {
        el.src = src
      }
      img.onerror = () => {
        if (error) el.src = error
      }
      img.src = src
    }

    // 兼容极少数不支持 IntersectionObserver 的环境
    if (!('IntersectionObserver' in window)) {
      load()
      return
    }

    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          load()
          io.disconnect()
        }
      },
      { rootMargin }
    )

    io.observe(el)
    el.__vLazyIO__ = io
  },
  unmounted(el) {
    el.__vLazyIO__?.disconnect?.()
    delete el.__vLazyIO__
  },
}

